import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { IconEdit } from '@calendly/ui/components/glyphs/IconEdit';
import { IconButton } from '@calendly/ui/components/icon-button';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorIconActive, colorIconSecondary } from '@calendly/ui/theme';
const cardCss = "c5v7gdc";
const iconBoxCss = "ivpgdbk";
const contentCss = "c1f78tst";
const titleCss = "t3uayd8";
const subtitleCss = "s1pep2p9";
const mainRegionCss = "mlruwnp";
const actionsCss = "a1v7zyb2";
const actionSlotCss = "a900wnp";
const customizeLabel = () => I18n.t('publisher.event_type_editor.sections.more_options.notifications.customize');

// Presentational card for the new CRUD notifications design: leading icon in a
// bordered box, title + timing subtitle, and trailing edit / toggle actions.
export const NotificationCard = ({
  icon,
  iconActive = false,
  title,
  subtitle,
  titleMuted = false,
  onEdit,
  toggle,
  disabled = false,
  'data-testid': dataTestId
}) => {
  const isEditable = !!onEdit && !disabled;
  const editLabel = customizeLabel();
  const mainContent = <>
      {icon ? <div className={iconBoxCss} aria-hidden="true">
          <UiIcon icon={icon} size="medium" title="" color={iconActive ? colorIconActive : colorIconSecondary} />
        </div> : null}
      <div className={contentCss}>
        <LabelText size="large" color={titleMuted ? 'muted' : 'standard'} className={titleCss}>
          {title}
        </LabelText>
        {subtitle ? <BodyText color="muted" size="small" className={subtitleCss}>
            {subtitle}
          </BodyText> : null}
      </div>
    </>;
  return <div className={cardCss} data-testid={dataTestId}>
      {isEditable ? <BareButton type="button" className={mainRegionCss} onClick={onEdit} aria-label={editLabel} title={editLabel}>
          {mainContent}
        </BareButton> : <div className={mainRegionCss}>
          {mainContent}
        </div>}
      <div className={actionsCss}>
        {onEdit ? <div className={actionSlotCss}>
            <IconButton appearance="ghost" size="small" icon={IconEdit} onClick={onEdit} disabled={disabled} title={editLabel} aria-label={editLabel} />
          </div> : null}
        {toggle ? <div className={actionSlotCss}>{toggle}</div> : null}
      </div>
    </div>;
};

require("./notification_card.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./notification_card.js");